import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { findOptions } from "../../../../../helpers/StringHelper";
import {
  streamOptions,
  historyOptions,
  deliveryOptions,
  licensingOptions,
  accessbilityOptions,
} from "../../../../DataStore/components/Settings/config";

const Style = styled.div`
  .row-cont {
    display: flex;
    padding: var(--size) 0px;
    border-bottom: 1px solid var(--base-gray-30);

    &:first-of-type {
      padding-top: 0px;
    }

    &:last-of-type {
      border-bottom: 0px;
      padding-bottom: 0px;
    }

    label {
      margin-bottom: 0px;
      color: var(--base-gray-70);

      &.value {
        color: var(--base-gray-90);
      }
    }
  }
`;

export default function DataSettings({ item }) {
  const { t } = useTranslation();
  const channel = {
    accessibility: findOptions(item?.channel?.accessibility, accessbilityOptions),
    availabilityHistory: findOptions(item?.channel?.history, historyOptions),
    availabilityStream: findOptions(item?.channel?.stream, streamOptions),
    delivery: findOptions(item?.channel?.delivery || 'custom', deliveryOptions),
    licensing: findOptions(item?.channel?.licensing, licensingOptions),
  }

  return (
    <Style>
      <div className="row-cont">
        <label className="flex-1">
          {t('Accessibility')}
        </label>
        <label className="value">
          {t(channel.accessibility)}
        </label>
      </div>

      <div className="row-cont">
        <label className="flex-1">
          {t('Availability History')}
        </label>
        <label className="value">
          {t(channel.availabilityHistory)}
        </label>
      </div>

      <div className="row-cont">
        <label className="flex-1">
          {t('Availability Stream')}
        </label>
        <label className="value">
          {t(channel.availabilityStream)}
        </label>
      </div>

      <div className="row-cont">
        <label className="flex-1">
          {t('Delivery')}
        </label>
        <label className="value">
          {t(channel.delivery)}
        </label>
      </div>

      <div className="row-cont">
        <label className="flex-1">
          {t('Licensing')}
        </label>
        <label className="value">
          {t(channel.licensing)}
        </label>
      </div>
    </Style>
  );
}
